// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "a[data-v-125401fa]{letter-spacing:2px}@media (max-width: 768px){.uk-navbar-nav>li>a[data-v-125401fa]{padding:0 8px}}\n", ""]);
// Exports
module.exports = exports;
